export default "__VITE_ASSET__CKkaLg76__"